import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { CREATE_WALLET_NAV, RESTORE_WALLET_NAV } from '../constants/navigation'
import { WALLET_STORAGE_ACTIONS, WALLET_UNLOCK_ACTIONS } from '../store/actions/wallet'
import TermsModal from '../components/TermsModal/TermsModal'

const { lockWallet } = WALLET_UNLOCK_ACTIONS

export default (ChildComponent) => {
  class ComposedComponent extends Component {
    componentDidMount() {
      const { wallet } = this.props

      if (!wallet.address) {
        this.props.checkWalletStorage()
      }
    }

    componentDidUpdate(oldProps) {
      const { checkingStorage, wallet, history } = this.props
      const { pathname } = history.location

      if (oldProps.checkingStorage && !checkingStorage) {
        if (!wallet.address && pathname !== CREATE_WALLET_NAV && pathname !== RESTORE_WALLET_NAV) {
          history.push(CREATE_WALLET_NAV)
        }
      }
    }

    render() {
      const { policyAccepted } = this.props
      return (
        <React.Fragment>
          <ChildComponent {...this.props} />
          <TermsModal show={!policyAccepted} />
        </React.Fragment>
      )
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(translate()(ComposedComponent))
}

const mapStateToProps = ({ walletReducer, authReducer }) => {
  const { walletProfile, storageProfile } = walletReducer
  return {
    policyAccepted: authReducer.policyAccepted,
    wallet: walletProfile.wallet,
    loading: walletProfile.loading,
    unlocked: walletProfile.unlocked,
    checkingStorage: storageProfile.checkingStorage
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    ...WALLET_STORAGE_ACTIONS,
    lockWallet
}, dispatch)


// WEBPACK FOOTER //
// ./src/hoc/requireWallet.js